module.exports = __webpack_public_path__ + "img/KIN.70244114.svg";